module.exports = __webpack_public_path__ + "media/images/850/sleep_apnea_get_good_sleep-ea994631fb820f39bc80773716c69665.jpg";